import { render, staticRenderFns } from "./other-income-list.html?vue&type=template&id=1386aa28&scoped=true&"
import script from "./other-income-list.js?vue&type=script&lang=js&"
export * from "./other-income-list.js?vue&type=script&lang=js&"
import style0 from "./OtherIncomeList.vue?vue&type=style&index=0&id=1386aa28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386aa28",
  null
  
)

component.options.__file = "OtherIncomeList.vue"
export default component.exports